export default "__VITE_ASSET__d126b717__"